import React from "react";
import { useTheme } from "../../views/Common/Theme/ThemeProvider";

const DataRolloverIcon = () => {
  const { theme, toggleTheme } = useTheme();
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.5 11.8125V12.9375H14.4832C13.8595 13.8092 13.0364 14.5193 12.0826 15.0085C11.1288 15.4977 10.0719 15.7519 9 15.75C5.27794 15.75 2.25 12.7221 2.25 9H1.125C1.125 13.3425 4.6575 16.875 9 16.875C11.4497 16.875 13.7104 15.7494 15.1875 13.8684V14.625H16.3125V11.8125H13.5Z"
        fill={`${theme === "light" ? "#373737" : "white"}`}
      />
      <path
        d="M12.6591 6.54581L9.29025 4.57706C9.20426 4.52676 9.10645 4.50021 9.00683 4.50011C8.9072 4.50001 8.80934 4.52637 8.72325 4.57649L5.34206 6.54524C5.25703 6.59473 5.18647 6.66565 5.13741 6.75093C5.08836 6.83621 5.06253 6.93286 5.0625 7.03124V10.9687C5.06253 11.0671 5.08836 11.1638 5.13741 11.2491C5.18647 11.3343 5.25703 11.4053 5.34206 11.4547L8.72325 13.4235C8.80691 13.4735 8.90254 13.4999 9 13.5C9.09788 13.5 9.2025 13.4747 9.29025 13.4229L12.6591 11.4542C12.7438 11.4046 12.8141 11.3337 12.8629 11.2485C12.9118 11.1634 12.9375 11.0669 12.9375 10.9687V7.03124C12.9375 6.93307 12.9118 6.8366 12.8629 6.75144C12.8141 6.66628 12.7438 6.59538 12.6591 6.54581ZM9.00619 5.71331L11.2601 7.03124L9.00619 8.34862L6.74325 7.03124L9.00619 5.71331ZM6.1875 8.00999L8.4375 9.32062V11.9559L6.1875 10.6453V8.00999ZM9.5625 11.9616V9.32737L11.8125 8.01224V10.6464L9.5625 11.9616Z"
        fill={`${theme === "light" ? "#373737" : "white"}`}
      />
      <path
        d="M9 1.12499C7.80803 1.12327 6.63132 1.39312 5.55921 1.91407C4.4871 2.43502 3.54776 3.19337 2.8125 4.13156V3.37499H1.6875V6.18749H4.5V5.06249H3.51675C4.14055 4.19076 4.96362 3.48071 5.91741 2.99149C6.87119 2.50227 7.92807 2.24805 9 2.24999C12.7221 2.24999 15.75 5.27793 15.75 8.99999H16.875C16.875 4.65749 13.3425 1.12499 9 1.12499Z"
        fill={`${theme === "light" ? "#373737" : "white"}`}
      />
    </svg>
  );
};

export default DataRolloverIcon;
